import { EditorProvider, useCurrentEditor } from '@tiptap/react';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import useShortcuts from '../../../hooks/shortcuts/useShortcuts';
import useDynamicData from '../../../hooks/template/useDynamicData';
import { DynDataExtension } from '../../editor/extensions/DyncDataExtension';
import { ExtendExtension } from '../../editor/extensions/ExtendExtension';
import { tiptapExtensions } from '../../editor/tiptapExtensions';
import ToolbarEditor from '../../editor/ToolbarEditor';

const handleToolBarSelect = (variant) => {
  if (variant === 'default') {
    return <ToolbarEditor />;
  }
  return <></>;
};

export const ChangeContent = ({ handleLoadEditor }) => {
  const { editor } = useCurrentEditor();
  const [isEditorLoaded, setIsEditorLoaded] = useState(false);

  useEffect(() => {
    if (editor && !isEditorLoaded) {
      handleLoadEditor(editor);
      setIsEditorLoaded(true);
    }
  }, [editor, isEditorLoaded]);

  return <></>;
};

export const ComponentRTE = ({
  variant,
  extensions,
  content,
  onChange,
  onCursorPosition,
}) => {
  const profile = useSelector((state) => state?.login?.profile);
  const [currentContent, setCurrentContent] = useState(null);
  const [currentEditor, setCurrentEditor] = useState(null);
  const { data } = useShortcuts(profile?._id);
  const { dynDatas } = useDynamicData({});

  const shortcutExtensionExtendRef = useRef(null);
  const shortcutExtensionDynDataRef = useRef(null);

  const currentExtension = useMemo(() => {
    const defaultValue = extensions || tiptapExtensions;
    const extend = ExtendExtension(data?.shortcuts || []);
    const dynData = DynDataExtension(dynDatas || []);

    shortcutExtensionExtendRef.current = extend;
    shortcutExtensionDynDataRef.current = dynData;

    return [...defaultValue, extend, dynData];
  }, []);

  const handleLoadEditor = (editor) => {
    if (!editor) return;
    setCurrentEditor(editor);
  };

  const handleUpdate = ({ editor }) => {
    const data = {
      json: editor.getJSON(),
      html: editor.getHTML(),
    };
    setCurrentContent(data);
    if (onCursorPosition) {
      const { from, to } = editor.state.selection;
      onCursorPosition({ to, from, editor });
    }
  };

  // const handleCursor = ({ editor }) => {
  //   const json = editor.getJSON();
  //   const $anchor = editor.state.selection.$anchor;

  //   // Calculer le chemin dans l'arbre JSON
  //   let pathArray = [];
  //   let textOffset = 0; // Position dans le texte du nœud

  //   for (let d = 0; d <= $anchor.depth; d++) {
  //     const index = $anchor.index(d);
  //     pathArray.push(index);
  //   }

  //   // Calculer l'offset dans le texte du nœud final
  //   if ($anchor.parent && $anchor.parent.isText) {
  //     textOffset = $anchor.parentOffset;
  //   }
  //   const position = {
  //     pathArray,
  //     textOffset,
  //     from,
  //     to,
  //     json,
  //   };

  //   if (onCursorPosition) {
  //     onCursorPosition(position);
  //   }
  // };

  useEffect(() => {
    if (!currentContent) {
      return;
    }
    onChange(currentContent);
  }, [currentContent]);

  useEffect(() => {
    if (
      data?.shortcuts &&
      shortcutExtensionExtendRef.current?.options?.setShortcuts
    ) {
      shortcutExtensionExtendRef.current.options.setShortcuts(data.shortcuts);
    }
  }, [data?.shortcuts]);

  useEffect(() => {
    if (dynDatas && shortcutExtensionDynDataRef.current?.options?.setList) {
      shortcutExtensionDynDataRef.current.options.setList(dynDatas);
    }
  }, [dynDatas]);

  useEffect(() => {
    if (currentEditor) {
      currentEditor.commands.setContent(content);
      setCurrentContent(content);
    }
  }, [currentEditor, content]);

  return (
    <EditorProvider
      slotBefore={handleToolBarSelect(variant)}
      extensions={currentExtension}
      // onSelectionUpdate={handleCursor}
      onBlur={handleUpdate}
      content={content || null}
    >
      <ChangeContent handleLoadEditor={handleLoadEditor} />
    </EditorProvider>
  );
};
